import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  list:   (params)   => api.get('/v1/campaigns', { params }).then(unwrap),
  get:    (id)       => api.get(`/v1/campaigns/${id}`).then(unwrap),
  create: (body)     => api.post('/v1/campaigns', body).then(unwrap),
  // The backend exposes PUT /v1/campaigns/{id} (CampaignController) — not PATCH.
  update: (id, body) => api.put(`/v1/campaigns/${id}`, body).then(unwrap),
  remove: (id)       => api.delete(`/v1/campaigns/${id}`).then(unwrap),

  launch: (id) => api.post(`/v1/campaigns/${id}/launch`).then(unwrap),
  pause:  (id) => api.post(`/v1/campaigns/${id}/pause`).then(unwrap),
  resume: (id) => api.post(`/v1/campaigns/${id}/resume`).then(unwrap),
  cancel: (id) => api.post(`/v1/campaigns/${id}/cancel`).then(unwrap),

  stats: (id)         => api.get(`/v1/campaigns/${id}/stats`).then(unwrap),
  sends: (id, params) => api.get(`/v1/campaigns/${id}/sends`, { params }).then(unwrap), // {status}

  previewSegment: (body) => api.post('/v1/campaigns/preview-segment', body).then(unwrap),
};
